import { supabase } from './supabase';

export const signUp = async (
  email: string,
  password: string,
  companyData: {
    name: string;
    phone: string;
  }
) => {
  if (password.length < 6) {
    throw new Error('Password must be at least 6 characters long');
  }

  if (!companyData.name.trim()) {
    throw new Error('Company name is required');
  }

  if (!companyData.phone.trim()) {
    throw new Error('Phone number is required');
  }

  try {
    const { data, error: authError } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          company_name: companyData.name
        }
      }
    });

    if (authError) {
      throw new Error(authError.message);
    }

    if (!data.user) {
      throw new Error('Registration failed');
    }

    // Create company profile
    const { error: companyError } = await supabase
      .from('companies')
      .insert([
        {
          id: data.user.id,
          name: companyData.name,
          email,
          phone: companyData.phone,
          services: [],
          brands: []
        }
      ])
      .select()
      .single();

    if (companyError) {
      // If company creation fails, delete the auth user
      throw new Error('Failed to create company profile: ' + companyError.message);
    }

    // Create company_users entry with owner role
    const { data: roleData, error: roleError } = await supabase
      .from('company_users')
      .insert({
        company_id: data.user.id,
        user_id: data.user.id,
        role: 'owner',
        status: 'active',
        created_by: data.user.id
      })
      .select();

    if (roleError) {
      // If error is duplicate key, that's okay - the role already exists
      if (!roleError.message.includes('duplicate key')) {
        throw new Error('Failed to set user role: ' + roleError.message);
      }
    }

    // Add delay to ensure everything is created and propagated
    await new Promise(resolve => setTimeout(resolve, 1000));

    // Return the auth data
    return data;
  } catch (err) {
    console.error('Registration error:', err);
    throw err instanceof Error ? err : new Error('Registration failed');
  }
};

export const signIn = async (email: string, password: string) => {
  if (password.length < 6) {
    throw new Error('Password must be at least 6 characters long');
  }

  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    throw new Error(error.message);
  }

  return data;
};